import React from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'components/Common/TextAreaAutosize';
import Icon from 'components/Utils/NewIcon';
import PharmacyBadge from 'components/Pharmacy/PharmacyBadge';
import AttachmentsViewer from 'components/Utils/AttachmentsViewer';
import CalendarUtils from 'services/CalendarUtils';
import { DetailsPanelTopBar } from 'services/UIUtils';
import CPPUtils from 'services/CPPUtils';
import PhysicianUtils from 'services/PhysicianUtils';
import './style.scss';
import { api } from 'careand-redux/api/ApiThunks';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { useAppSelector } from 'careand-redux/store';
import AIUtils from 'services/AIUtils';

const detailedDateFormat = 'Do MMMM YYYY h:mm A';

const PrescriptionDetails = ({ prescription, onClose, title = 'Prescription Details' }) => {
  const dispatch = useAppDispatch();

  const physician = useAppSelector((state) => state.physicians.byId[prescription.physician_id]);
  const patient = useAppSelector((state) => state.patients.byId[prescription.patient_id]);

  function fetchPrescription(url, dispatchOptions) {
    return dispatch(
      api.HealthRecords.getPrescriptionAttachment({
        patientId: prescription.patient_id,
        prescriptionId: prescription.id,
        resource: { url },
      }),
      dispatchOptions,
    );
  }

  return (
    <div className="details-panel padded-box prescription-details scroll-list">
      <DetailsPanelTopBar name={title} onClose={onClose} />
      <PhysicianDetails physician={physician} prescription={prescription} />
      <Medications prescription={prescription} />
      {prescription.additional_information !== undefined && (
        <>
          <span className="small-title">Additional Information for Pharmacist</span>

          <TextareaAutosize
            name="additional_information"
            value={prescription.additional_information}
            disabled={true}
          />
        </>
      )}
      <PharmacyWrapper prescription={prescription} />
      {prescription.note && (
        <div>
          <span className="small-title">Patient Notes</span>
          <pre>{prescription.note}</pre>
        </div>
      )}
      <br />
      {!!prescription.attachments && (
        <AttachmentsViewer
          title="Prescription"
          showFax={true}
          patient={patient}
          onFetch={(url, dispatchOptions) => fetchPrescription(url, dispatchOptions)}
          attachments={prescription.attachments}
        />
      )}
      <br />
    </div>
  );
};

export const Medications = ({ prescription }) => (
  <ul className="medications">
    {(prescription.medications || []).map((medication, index) => (
      <li className="medication" key={index}>
        {CPPUtils.getPrescriptionMedicationSummary(medication)}
      </li>
    ))}
  </ul>
);

const PhysicianDetails = ({ physician, prescription }) => (
  <div className="physician-details">
    <div className="wrapper">
      <Icon src="calendar-clock" />
      <span className="prescription-date">
        {CalendarUtils.format(prescription.date, detailedDateFormat)}
      </span>
    </div>
    <div className="wrapper">
      <Icon src="user-doctor" />
      <span className="physician-name">{PhysicianUtils.getName(physician)}</span>
    </div>
  </div>
);

const PharmacyWrapper = ({ prescription }) =>
  prescription.pharmacy !== undefined && (
    <div className="row">
      <PharmacyBadge pharmacy={prescription.pharmacy} />
    </div>
  );

PrescriptionDetails.propTypes = {
  prescription: PropTypes.object.isRequired,
  onClose: PropTypes.func,
};

export default PrescriptionDetails;
